'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./Tool.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tool = function Tool(props) {
    var classes = { dragging: props.isDragging, active: props.isActive, draggable: props.isDraggable };

    var toolNameElement = props.name ? _react2.default.createElement(
        'span',
        { className: 'tool-name' },
        props.name
    ) : null;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('Tool', props.className, classes),
            onClick: props.handleClick,
            onMouseDown: props.handleMouseDown,
            title: props.tooltip },
        _react2.default.createElement(
            'div',
            { className: 'icon' },
            props.children
        ),
        toolNameElement
    );
};

// Styles


Tool.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
    name: _propTypes2.default.string,
    iconName: _propTypes2.default.string,
    isDraggable: _propTypes2.default.bool,
    isDragging: _propTypes2.default.bool,
    isActive: _propTypes2.default.bool,
    handleClick: _propTypes2.default.func,
    handleMouseDown: _propTypes2.default.func,
    className: _propTypes2.default.string,
    tooltip: _propTypes2.default.string
};

exports.default = Tool;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/Tool.js
// module id = 110
// module chunks = 0